module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/gallery5-41259497c1c1e2942299de669e3898a2.jpg";